import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import type { RadioProps } from '@mui/material/Radio';
import type { SxProps, Theme } from '@mui/material/styles';

import { mergeSx } from '@/utils/mergeSx';

import { labeledRadioStyles as sx } from './LabeledRadio.styles';

type Props = {
	label: string;
	checked: boolean;
	onChange: RadioProps['onChange'];
	disabled?: boolean;
	name?: string;
	value?: string | number;
	customSx?: SxProps<Theme>;
	indicateError?: boolean;
	isDirty?: boolean;
};

export const LabeledRadio = ({
	label,
	checked,
	onChange,
	disabled,
	name,
	value,
	customSx,
	indicateError,
	isDirty
}: Props) => {
	return (
		<FormControlLabel
			label={label}
			sx={mergeSx(sx.formControl(!!indicateError, !!isDirty), customSx)}
			control={
				<Radio
					checked={checked}
					onChange={onChange}
					disabled={disabled}
					name={name}
					value={value}
					color='primary'
					sx={sx.radio(!!indicateError, !!isDirty)}
				/>
			}
		/>
	);
};
